<template>
  <div class="attachments" id="AAA">
    <div class="display">
      <video-player :fill-parent="true"
                    :ratio="video.ratio"
                    :video-url="video.storage.displayUrl"
                    v-if="video"/>
      <div v-if="images.length">
        <div :data-ratio="thumbnail.ratio" :key="n" v-for="(thumbnail, n) in images">
          <img :src="thumbnail.displayUrl" v-show="thumbnail.displayUrl">
        </div>
      </div>
      <!--<div v-if="!images.length" class="attachment placeholder"></div>-->
    </div>
    <div class="toolbar">
      <div class="controls">
        <div class="video-player">
          <div class="button play">
            <div class="icon play"></div>
          </div>
          <div class="button sound">
            <div class="icon">
              sound
            </div>
          </div>
        </div>
        <div class="caption">
          Here is the caption for the above photograph or video
        </div>
      </div>
      <a class="button" href="#">
        <div class="icon arrow-left"></div>
      </a>
      <a class="button">
        <div class="icon arrow-right"></div>
      </a>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '../VideoPlayer'

export default {
  components: {
    'video-player': VideoPlayer
  },
  props: ['video', 'images']
}
</script>

<style scoped>
</style>
